/**
 * Minimal analytics wrapper.
 * Swap the body of trackEvent for GA4 / Plausible / GTM when ready.
 */
export function trackEvent(name, props = {}) {
  // eslint-disable-next-line no-console
  console.log(`[analytics] ${name}`, props);
}
